import React from 'react'
import MaterialTable from '@material-table/core'
import { format } from 'date-fns'
import { Colors } from '@auteco/theme'

const EventosTable = ({ eventos }) => {
  // Formatear fecha Unix a Mes y Año
  const formatUnixToMonthYear = (unix) => {
    try {
      return format(new Date((unix + 86000) * 1000), 'MMM yyyy')
    } catch (e) {
      return ''
    }
  }

  // Preparar datos para la tabla
  const transformEventosData = (eventosData) => {
    const allMonths = new Set()
    const rows = eventosData.map((evento) => {
      const monthlyValues = {}

      // Sumar valores por mes
      evento.valores.forEach(({ mes_unix, valor }) => {
        const monthYear = formatUnixToMonthYear(mes_unix)
        allMonths.add(monthYear)
        monthlyValues[monthYear] = (monthlyValues[monthYear] || 0) + valor
      })

      return {
        nombre: evento.nombre,
        ...monthlyValues,
      }
    })

    // Ordenar meses por fecha
    const orderedMonths = Array.from(allMonths).sort((a, b) => {
      const dateA = new Date(a)
      const dateB = new Date(b)
      return dateA - dateB
    })

    // Crear columnas dinámicamente
    const columns = [
      { title: 'Evento', field: 'nombre' },
      ...orderedMonths.map((month) => ({ title: month, field: month })),
    ]

    return { columns, rows }
  }

  const { columns, rows } = transformEventosData(eventos)

  return (
    <MaterialTable
      title="Eventos por Mes"
      data={rows}
      columns={columns}
      options={{
        pageSize: 20,
        columnsButton: true,
        pageSizeOptions: [20, 50, 100],
        headerStyle: {
          backgroundColor: '#4c75aa',
          color: '#f1f1f1',
          fontSize: '14px',
          fontWeight: 700,
          position: 'sticky',
          zIndex: '10',
        },
        maxBodyHeight: '500px',
        rowStyle: (rowData, index) => ({
          backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
          padding: '5px',
          fontSize: '12px',
        }),
      }}
    />
  )
}

export { EventosTable }
